export default "__VITE_ASSET__BcPd6bcY__"